import "./_base-input.scss";

interface BaseInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	icon?: React.ReactNode;
	hasError?: boolean;
	ref?: React.Ref<HTMLInputElement>;
}

export const BaseInput = ({
	icon,
	hasError = false,
	className = "",
	ref,
	...props
}: BaseInputProps) => {
	const classes = [
		"base-input",
		hasError ? "base-input--error" : "",
		icon ? "base-input--with-icon" : "",
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<div className={classes}>
			{icon && <div className="base-input__icon">{icon}</div>}
			<input ref={ref} className="base-input__field" {...props} />
		</div>
	);
};

BaseInput.displayName = "BaseInput";
